
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chess Championship  </h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm chess-fest section-banner-bg-1">
    <div class="container">
    	<div class="row ">

            <div class="sec-title text-center">
                <h2>fide Chess <span > Competition</span></h2>
            </div>

                <!-- <div class="row">
                    <div class="col-lg-6">
		                <div class="tab-content">

			                    <div class="widget_title inner-title">
			                        <h4>CHESS CHAMPIONSHIP 2020</h4>
			                    </div>
			                     <div class="text-center">
			                        <iframe src="https://drive.google.com/file/d/1KkKyZB7aB5kcTKMyT4I1kvLUsuXoGavm/preview?" height="600" width="800" class="iframe-sm"></iframe>
			                    </div>

		                </div>
                    </div>

                    <div class="col-lg-6">
		                <div class="tab-content">
			                     <div class="widget_title inner-title">
			                        <h4>ONE DAY RAPID CHAMPIONSHIP 2019</h4>
			                    </div>
			                     <div class="text-center">
			                        <iframe src="https://drive.google.com/file/d/1N7dXRjpMDXTA93YKGMbj4lZlHnrk4Hc2/preview" height="600" width="800" class="iframe-sm"></iframe>
			                    </div>

		                </div>
		            </div>
                </div> -->
                <div class="col-md-6">
				    <div class="widget_title inner-title">
			            <h4>CHESS CHAMPIONSHIP 2020</h4>
						<iframe style="width: 100%; height: 700px;" src="https://urlzs.com/pcAv8"></iframe>
					</div>
                </div>

                <div class="col-lg-6">

                    <div class="tab-content">
                        <div class="widget_title inner-title">
                            <div class="row">
                                <div class="col-lg-9">
                                    <h4>ONE DAY RAPID CHAMPIONSHIP 2019</h4>
                                </div>
                                <div class="col-lg-3">
                                    <a href="result" class="cmn-white-button"><span>
                                    View Results</span>
                                    </a>

                                </div>
                            </div>
					    <iframe style="width: 100%; height: 700px;" src="https://urlzs.com/drFgf"></iframe>
			            </div>
                    </div>
                    </div>

        </div>
    </div>
</section>
